import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useContext } from 'react';
import { BookerContext } from '../Booker.js';
const Field = ({ children, className, hasErrors }) => {
    const { vertical, useTailwindPrefix, version } = useContext(BookerContext);
    return (_jsx("div", Object.assign({ className: classNames('itm-booker-field', {
            'md:text-widget-pill-a11y md:border-none md:bg-transparent': version === 'padded' && !vertical && !useTailwindPrefix,
            'md:tw-text-widget-pill-a11y md:tw-border-none md:tw-bg-transparent': version === 'padded' && !vertical && useTailwindPrefix,
            'border bg-white flex gap-2 items-center px-[var(--booker-field-padding-x)] leading-[45px] cursor-pointer border-gray-200 rounded-[3px]': !useTailwindPrefix,
            'tw-border tw-bg-white tw-flex tw-gap-2 tw-items-center tw-px-[var(--booker-field-padding-x)] tw-leading-[45px] tw-cursor-pointer tw-border tw-border-gray-200 tw-rounded-[3px]': useTailwindPrefix,
            'md:rounded-none': !vertical && !useTailwindPrefix,
            'md:tw-rounded-none': !vertical && useTailwindPrefix,
            'border-b-red-400': hasErrors && !useTailwindPrefix,
            'tw-border-b-red-400': hasErrors && useTailwindPrefix,
        }, className) }, { children: children })));
};
export default Field;
